import { render, staticRenderFns } from "./ApplicationPage.vue?vue&type=template&id=25044a10&"
import script from "./ApplicationPage.vue?vue&type=script&lang=js&"
export * from "./ApplicationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports